import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DnsIcon from '@mui/icons-material/Dns'

export const AgencyForm = ({
  id, agencyName, opUnit, codSociety, serverId,
  setId, setAgencyName, setOpUnit, setCodSociety, setServerId,
  serverOptions, createAgency, clearFields, onOpenNewServerDialog
}) => (
  <>
    <Stack direction='row' alignItems='center' spacing={1} sx={{ mb: 2 }}>
      <AddIcon fontSize='small' color='primary' />
      <Typography variant='subtitle1' fontWeight={600} color='text.primary'>
        Nuova Agenzia
      </Typography>
    </Stack>

    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 2, mb: 2 }}>
      <TextField
        label='ID'
        size='small'
        fullWidth
        value={id}
        onChange={(e) => setId(e.target.value)}
        aria-label='ID agenzia'
      />
      <TextField
        label='Nome Agenzia'
        size='small'
        fullWidth
        value={agencyName}
        onChange={(e) => setAgencyName(e.target.value)}
        aria-label='Nome agenzia'
      />
      <TextField
        label='Codice Societa'
        size='small'
        fullWidth
        value={codSociety}
        onChange={(e) => setCodSociety(e.target.value)}
        aria-label='Codice societa'
      />
    </Box>

    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 2, mb: 2 }}>
      <TextField
        label='Unita Operativa'
        size='small'
        fullWidth
        value={opUnit}
        onChange={(e) => setOpUnit(e.target.value)}
        aria-label='Unita operativa'
      />
      <Stack direction='row' spacing={1.5} alignItems='flex-start'>
        <FormControl size='small' fullWidth>
          <InputLabel id='server-select-label'>Server</InputLabel>
          <Select
            labelId='server-select-label'
            value={serverId}
            onChange={(e) => setServerId(e.target.value)}
            label='Server'
          >
            <MenuItem value=''>
              <em>Scegliere server</em>
            </MenuItem>
            {serverOptions.map((s) => (
              <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip title='Aggiungi nuovo server'>
          <Button
            variant='outlined'
            size='small'
            onClick={onOpenNewServerDialog}
            startIcon={<DnsIcon />}
            aria-label='Inserisci nuovo server'
            sx={{ textTransform: 'none', fontWeight: 500, minWidth: 160, height: 40 }}
          >
            Nuovo Server
          </Button>
        </Tooltip>
      </Stack>
    </Box>

    <Stack direction='row' justifyContent='flex-end' spacing={1.5}>
      <Tooltip title='Pulisci tutti i campi'>
        <Button
          variant='outlined'
          color='inherit'
          size='small'
          onClick={clearFields}
          startIcon={<DeleteOutlineIcon />}
          aria-label='Pulisci campi'
          sx={{ textTransform: 'none', fontWeight: 500 }}
        >
          Pulisci
        </Button>
      </Tooltip>
      <Tooltip title='Crea una nuova agenzia'>
        <Button
          variant='contained'
          size='small'
          onClick={createAgency}
          startIcon={<AddIcon />}
          aria-label='Crea agenzia'
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Crea Agenzia
        </Button>
      </Tooltip>
    </Stack>
  </>
)
